<div class="content-wrapper" *blockUI="'section-block'">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="d-flex mb-1">
            <button type="button" class="btn btn-warning mr-1" rippleEffect (click)="showDetail(vault)">
                <span [data-feather]="'edit'" [class]="'mr-25'"></span>Düzenle</button>
        </div>

        <div class="card col-xl-6">
            <div class="card-header d-flex justify-content-between pb-0">
                <h4 class="card-title">{{vault?.title}}</h4>
                <div ngbDropdown class="chart-dropdown">
                    <button class="btn btn-sm border-0 p-50" ngbDropdownToggle type="button" id="dropdownItem4"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span [data-feather]="'eye'"></span>
                        {{vault?.typeName}}
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="d-flex justify-content-between mt-3">
                    <div class="text-center">
                        <p class="card-text mb-50">Toplam Tutar</p>
                        <span class="font-large-1 font-weight-bold">{{vault?.totalPrice | number:'1.1-2'}}</span>
                    </div>

                    <div class="text-center">
                        <p class="card-text mb-50">Toplam Hareket</p>
                        <span class="font-large-1 font-weight-bold">{{vault?.totalMovementCount}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" id="table-striped">
        <!-- Firma Hareketleri Tablosu -->
        <div class="col-6">
            <button type="button" class="btn btn-outline-info mb-1" rippleEffect
                (click)="showCreateMovement(vault?.id,1)">
                Firma Hareketi Ekle
            </button>
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Firma Hareketleri</h4>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th></th> <!-- Chevron için boş sütun -->
                                <th>Firma Adı</th>
                                <th>Tutar</th>
                                <th>Hareket Tarihi</th>
                                <th>Tür</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of vault?.companyVaultMovements">
                                <tr>
                                    <td>
                                        <button type="button" *ngIf="!item.isExpanded" (click)="toggleExpand(item)"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span data-feather="chevron-right"></span>
                                        </button>
                                        <button type="button" *ngIf="item.isExpanded" (click)="toggleExpand(item)"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span data-feather="chevron-down"></span>
                                        </button>
                                    </td>
                                    <td>{{item.companyName}}</td>
                                    <td>{{item.balance | number:'1.2-2'}}</td>
                                    <td>{{item.cratedAt | date: 'dd.MM.yyyy HH:mm'}}</td>
                                    <td>
                                        <span class="badge badge-pill mr-1" [ngClass]="{
                                    'badge-light-danger': item.kindId === 13,
                                    'badge-light-success': item.kindId === 15
                                }">
                                            {{ item.kindName }}
                                        </span>
                                    </td>
                                </tr>
                                <!-- Detay kısmı -->
                                <tr *ngIf="item.isExpanded">
                                    <td colspan="5">
                                        <div class="p-2">
                                            <p><strong>İşlemi Yapana Kişi: </strong>{{item.userName }}</p>
                                            <p><strong>Açıklama: </strong> {{ item.description ?? 'Açıklama yok.' }}</p>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="vault?.companyVaultMovements?.length < 1">
                                <td colspan="5">Hareket Bulunamadı</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-6">
            <button type="button" class="btn btn-outline-info mb-1" rippleEffect
                (click)="showCreateMovement(vault?.id,2)">
                Hesap Hareketi Ekle
            </button>
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Hesap Hareketleri</h4>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th></th> <!-- Chevron için boş sütun -->
                                <th>Hesap Adı</th>
                                <th>Tutar</th>
                                <th>Hareket Tarihi</th>
                                <th>Tür</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of vault?.vaultVaultMovements">
                                <tr>
                                    <td>
                                        <button type="button" *ngIf="!item.isExpanded" (click)="toggleExpand(item)"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span data-feather="chevron-right"></span>

                                        </button>
                                        <button type="button" *ngIf="item.isExpanded" (click)="toggleExpand(item)"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span data-feather="chevron-down"></span>
                                        </button>
                                    </td>
                                    <td>{{item.isVault == false ? item.vaultTitle : item.transferVaultTitle }}</td>
                                    <td>{{ item.isVault ? '-' + (item.balance | number:'1.2-2') : '+' + (item.balance |
                                        number:'1.1-2') }}</td>
                                    <td>{{item.cratedAt | date: 'dd.MM.yyyy HH:mm'}}</td>

                                    <td>
                                        <span class="badge badge-pill mr-1" [ngClass]="{
                                            'badge-light-danger': item.isVault,
                                            'badge-light-success': !item.isVault
                                        }">
                                            {{ item.kindName}}
                                        </span>
                                    </td>
                                </tr>
                                <!-- Detay kısmı -->
                                <tr *ngIf="item.isExpanded">
                                    <td colspan="5">
                                        <div class="p-2">
                                            <p><strong>İşlemi Yapana Kişi: </strong>{{item.userName }}</p>
                                            <p><strong>Açıklama: </strong> {{ item.description ?? 'Açıklama yok.' }}</p>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <td *ngIf="vault?.companyVaultMovements.length > 1">Hareket Bulunamadı</td>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>